import styled, { css } from "styled-components";

export const StyledBodyCollaboratorComment = styled.div<{
  $editMode?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & section:first-child > div {
    max-width: ${(props) => (props.$editMode ? "278px" : "initial")};
  }
`;

export const StyledFormFieldWrapper = styled.div<{
  $editMode?: boolean;
}>`
  display: grid;
  gap: 10px;
  grid-template-columns: ${(props) => (props.$editMode ? "1fr" : "120px  1fr")};
`;

export const StyledFixedHeight = styled.div<{ $isEmpty?: boolean }>`
  width: 100%;
  min-height: 100px;
  height: 100%;

  & .infoBox {
    height: 100%;
    ${({ $isEmpty }) =>
      $isEmpty
        ? css`
            display: flex;
            justify-content: center;
            align-items: center;
          `
        : undefined}
  }
`;
